import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollUpButton } from '@radix-ui/react-select';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

interface Props extends React.ComponentPropsWithoutRef<typeof ScrollUpButton> {
  ref?: React.Ref<React.ElementRef<typeof ScrollUpButton>>;
}

/**
 * @deprecated Use `SelectScrollUpButton` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectScrollUpButton({ className, ref, ...props }: Props) {
  const t = useTranslations('Common');

  return (
    <ScrollUpButton
      data-test='select-scroll-up'
      aria-label={t('selectScrollUpAria')}
      ref={ref}
      className={cn(
        'flex cursor-default items-center justify-center py-1',
        className
      )}
      {...props}
    >
      <FontAwesomeIcon icon={faChevronUp} className='size-4' />
    </ScrollUpButton>
  );
}

export default SelectScrollUpButton;
